import React, { FC, useState } from 'react';

// Shared UI Library Components
import { CustomIcon, EIconName, Loader } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './provided-consultations.scss';

// Components
import { TotalRangeItem } from '../total-range-item/total-range-item';

// Models
import { IProvidedConsultationsChart } from '../../../../interfaces/dashboard.interfaces';

type TProvidedConsultationsProps = {
  provided_consultations_chart?: IProvidedConsultationsChart,
  loading?: boolean,
};

export const ProvidedConsultations: FC<TProvidedConsultationsProps> = (
  {
    provided_consultations_chart: { audio_calls, paid_messages, video_calls, conversations } = {
      audio_calls: 0,
      paid_messages: 0,
      video_calls: 0,
      conversations: 0,
    },
    loading = false
  }: TProvidedConsultationsProps
) => {

  const [hideBlock, setHideBlock] = useState<boolean>(false);
  const totalConsultations =  (video_calls + audio_calls + paid_messages + conversations) || 100;

  const toggleHideBlockState = (): void => {
    setHideBlock(!hideBlock);
  }

  return (
    <div className="provided-consultations">
      <div className="provided-consultations--header">
        <div className="header-title">
          Provided Consultations
        </div>
        <div className={ `header-action header-action--${ hideBlock ? 'open' : 'hide' }` }
             onClick={ toggleHideBlockState }>
          { hideBlock ? 'Show' : 'Hide' } <CustomIcon size={ 'size-md' } name={ EIconName.ArrowDown }/>
        </div>
      </div>

      { loading && <div className="service-revenue--loader">
        <Loader size={ 'large' }/>
      </div> }

      <div className="provided-consultations--content" hidden={ hideBlock }>
        <TotalRangeItem data={ [totalConsultations, video_calls] }>
          <CustomIcon name={ EIconName.CameraOn } skipSize={true} /> { video_calls }
        </TotalRangeItem>
        <TotalRangeItem data={ [totalConsultations, audio_calls] }>
          <CustomIcon name={ EIconName.MicOn } skipSize={true} /> { audio_calls }
        </TotalRangeItem>
        <TotalRangeItem data={ [totalConsultations, conversations] }>
          <CustomIcon name={ EIconName.Chat } skipSize={true} /> { conversations }
        </TotalRangeItem>
        <TotalRangeItem data={ [totalConsultations, paid_messages] }>
          <CustomIcon name={ EIconName.Message } skipSize={true} /> { paid_messages }
        </TotalRangeItem>
      </div>
    </div>
  );
}
